// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__36FCH","header":"ReportDetails_header__13CJ5","title":"ReportDetails_title__1bmed","left":"ReportDetails_left__9dU43"};